module.exports = __webpack_public_path__ + "static/media/yunpian.7508a04a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/yunpian.png
// module id = 220
// module chunks = 0